import {ModelBase, NeoModel} from '@singularsystems/neo-core';
  
  @NeoModel
  export default class DashboardLookup extends ModelBase {
    public clientId: number = 0;
  
    public batchCount: number = 0;

    public isCampaignMessagesReview : boolean = false
  }